import React, { useState } from 'react';
import CourseScheduleSlots from './CourseScheduleSlots';

function ParentCourseForm() {
  const [course, setCourse] = useState({
    name: '',
    slug: '',
    description: '',
    max_attendees: '',
    color: '#ffffff',
    image: '',
    start_date: '',
    end_date: ''
  });
  const [slots, setSlots] = useState([{ weekday: 1, time: '', duration: '1.5' }]);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCourse(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) return;
    setError(null);
    setSuccess(null);

    if (!course.start_date) {
      setError('Bitte ein Startdatum angeben.');
      return;
    }
    if (course.end_date && course.end_date < course.start_date) {
      setError('Das Enddatum darf nicht vor dem Startdatum liegen.');
      return;
    }
    if (slots.some(slot => !slot.time || !slot.duration)) {
      setError('Bitte für alle Wochentermine Uhrzeit und Dauer angeben.');
      return;
    }

    setLoading(true);

    const courseData = {
      ...course,
      max_attendees: parseInt(course.max_attendees, 10),
      slots: slots.map(slot => ({
        weekday: slot.weekday,
        time: slot.time,
        duration: parseFloat(slot.duration)
      }))
    };

    fetch('/api/courses', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(courseData),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Fehler beim Erstellen des Kurses');
      }
      return response.json();
    })
    .then(data => {
      console.log('Kurs erfolgreich erstellt:', data);
      setSuccess(`Kurs "${data.data.name}" wurde erfolgreich erstellt!`);
      setCourse({
        name: '',
        slug: '',
        description: '',
        max_attendees: '',
        color: '#ffffff',
        image: '',
        start_date: '',
        end_date: ''
      });
      setSlots([{ weekday: 1, time: '', duration: '1.5' }]);
    })
    .catch(error => {
      console.error('Fetch error:', error);
      setError('Fehler beim Erstellen des Kurses. Ist der Backend-Server gestartet und erreichbar? Bitte überprüfen Sie die Browser-Konsole für weitere Details.');
    })
    .finally(() => {
      setLoading(false);
    });
  };

  return (
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">Neuen Kurs erstellen</h5>
        {success && <div className="alert alert-success">{success}</div>}
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="name" className="form-label">Kursname</label>
            <input type="text" className="form-control" id="name" name="name" value={course.name} onChange={handleChange} required />
          </div>
          <div className="mb-3">
            <label htmlFor="slug" className="form-label">Lernportal-Kennung (Slug, optional)</label>
            <input type="text" className="form-control" id="slug" name="slug" value={course.slug} onChange={handleChange} placeholder="z.B. scratch-kurs" />
            <div className="form-text">
              Nur fuer Kurse mit eigenem Lernportal (Scratch/KI/Python). Steuert den "Kurs oeffnen"-Link in
              "Mein Bereich", unabhaengig vom Kursnamen oben.
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="description" className="form-label">Beschreibung</label>
            <textarea className="form-control" id="description" name="description" value={course.description} onChange={handleChange} required></textarea>
          </div>
          <div className="mb-3">
            <label htmlFor="max_attendees" className="form-label">Maximale Teilnehmer</label>
            <input type="number" className="form-control" id="max_attendees" name="max_attendees" value={course.max_attendees} onChange={handleChange} required />
          </div>
          <div className="row mb-3">
            <div className="col-md-6">
              <label htmlFor="start_date" className="form-label">Startdatum</label>
              <input type="date" className="form-control" id="start_date" name="start_date" value={course.start_date} onChange={handleChange} required />
            </div>
            <div className="col-md-6">
              <label htmlFor="end_date" className="form-label">Enddatum (optional, leer lassen für laufende Kurse)</label>
              <input type="date" className="form-control" id="end_date" name="end_date" value={course.end_date} onChange={handleChange} />
            </div>
          </div>
          <div className="mb-3">
            <CourseScheduleSlots slots={slots} onChange={setSlots} />
          </div>
          <div className="mb-3">
            <label htmlFor="color" className="form-label">Kursfarbe</label>
            <input type="color" className="form-control form-control-color" id="color" name="color" value={course.color} onChange={handleChange} />
          </div>
          <div className="mb-3">
            <label htmlFor="image" className="form-label">Bild-URL</label>
            <input type="text" className="form-control" id="image" name="image" value={course.image} onChange={handleChange} />
          </div>
          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Wird erstellt...' : 'Kurs erstellen'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ParentCourseForm;
